/**
 * Audio-stories React Query key factory
 */
export const audioStoryKeys = {
  all: ['audio-stories'] as const,
  lists: () => [...audioStoryKeys.all, 'list'] as const,
  list: (familyId: string, filters?: { onlyFavorites?: boolean }) =>
    filters?.onlyFavorites
      ? ([...audioStoryKeys.lists(), familyId, 'favorites'] as const)
      : ([...audioStoryKeys.lists(), familyId] as const),
  details: () => [...audioStoryKeys.all, 'detail'] as const,
  detail: (audioStoryId: string) => [...audioStoryKeys.details(), audioStoryId] as const,
};
